import { render } from "./PhotoClassifyProp.vue?vue&type=template&id=0a8dcc4d&scoped=true"
import script from "./PhotoClassifyProp.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyProp.vue?vue&type=script&lang=js"

import "./PhotoClassifyProp.vue?vue&type=style&index=0&id=0a8dcc4d&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8dcc4d"]])

export default __exports__